import { AmateurProgramsLandingQuery, AMATEUR_PROGRAMS_LANDING_QUERY } from '@layouts/amateur-programs-landing'
import { fetchSSRData } from '@lib/ssr-fetch'

function AmateurProgramsLandingPage(props) {
  return <AmateurProgramsLandingQuery {...props} />
}

AmateurProgramsLandingPage.getInitialProps = async ({ query }) => {
  const result = await fetchSSRData({
    query,
    graphqlQuery: AMATEUR_PROGRAMS_LANDING_QUERY,
    variables: query,
    transform: (data) => data?.amateurEventsLandingCollection?.items?.[0],
  })
  return { ...result, ssrData: result.data }
}

export default AmateurProgramsLandingPage
